import * as types from '../mutation-types'
import { DOM } from '../../dom'
import { API } from '../../api'
import { FORMAT } from '../../data/core/format'
import { MOMENT_TIME } from '../../momenttime'
import { COLLATE_DATA_MANAGER, DATA, FATE_DATA_MANAGER, RECORD_DATA_MANAGER } from '../../data'
import { FORM } from '../../utils'

export default {
    namespaced: true,
    state: {
        showArea: false,
        selectedArea: [],
        showBirthday: false,
        selectedBirthday: [],
        formData: {
            // 'situation': 0,'strong': 0,'reminder': 0,'f_group': 0,'real_time': 0,'zwzs': 0
            'f_name': '', 
            'f_group': 0,   
            'label': '',   
            'remark': '' ,
            'sex': 0,            
            'birthday': Number,  
            'location': '',
            'real_time': 0,
            'zwzs': 1 
        },
        advanced: {
            siZhuEightWordArr: [],
            showChooseItemPop: false,
            collateClickBoxPos: [],
            collateChooseItemList: [],
            sameEightWordList: []
        },
        chooseGroupFromPage: '',
        curStartCollateType: '',
        chooseLabelFromPage: ''
    },
    getters: {},
    mutations: {
        [types.COLLATE_CONFIRM_AREA](state, areaArr) {
            var checkData = areaArr[0]['name'];
            console.log("types.COLLATE_CONFIRM_AREA", areaArr, checkData)
            if (checkData.indexOf("不选择") != -1 ) {
                state.selectedArea = [];
                state.formData.location = "";
            }else if(checkData.indexOf("海外地区") != -1){
                state.selectedArea = ['海外地区 北半球'];
                state.formData.location = COLLATE_DATA_MANAGER.getPaiPanParamsLocation(areaArr);
            }else {
                state.selectedArea = COLLATE_DATA_MANAGER.getSelectedAreaStringByArr(areaArr);
                state.formData.location = COLLATE_DATA_MANAGER.getPaiPanParamsLocation(areaArr);
            }
        },
        [types.COLLATE_CONFIRM_BIRTHDAY](state, params) {
            console.log("types.COLLATE_CONFIRM_BIRTHDAY", params.inputData)
            state.selectedBirthday = COLLATE_DATA_MANAGER.getSelectedBirthdayStringByData(params.inputData);
            state.formData.birthday = DATA.getTimeInfoByInputData(params.inputData, 'datestr');
            // 处理时辰不详的逻辑
            state.formData.unknown = params.inputData.unknownTime ? 1 : 0;
            if(params.cb && typeof(params.cb) == 'function') {
                params.cb();
            }
        },
        [types.COLLATE_START_COLLATE](state, params) {
            
            // 如果选了出生地的话，传入真太阳时
            if(params.formData.location && params.formData.location != ''){
                if(FORM.checkFormLocationSpecial(params.formData.location)) {
                    params.formData['real_time'] = params.formData.birthday;
                }else {
                    params.formData['real_time'] = FORMAT.getRealSunTimeByData(params.formData.location, params.formData.birthday);
                }
            }
            var rt = parseInt(AppFate.$store.state.setting.settingConfigData.rt);
            params.formData['rt'] = rt;

            console.log("COLLATE_START_COLLATE---", params.formData);
            API.addPaiPan(params.formData, function (data) {

                AppFate.$store.dispatch('detail/resetData');
                AppFate.$store.dispatch('detail/initDetail', data);
                if(params.cb && typeof(params.cb) == 'function') {
                    params.cb(data.id);
                }

                // 更新列表数据
                AppFate.$store.dispatch('record/updateRecordListData', data);
                // 更新分组数据
                var groupData = AppFate.$store.state.group.groupData;
                var recordData = RECORD_DATA_MANAGER.getRecordDataByData(data, groupData);
                AppFate.$store.dispatch('group/updateGroupListData', recordData);
                // 处理过滤列表数据
                AppFate.$store.dispatch('record/updateRecordFilterList');
            });
        },
        [types.COLLATE_SIZHU_INIT_DATA](state) {
            // 初始化当前时间的四柱
            var formData = Object.assign({}, state.formData);
            formData.birthday = formData.birthday ? formData.birthday : MOMENT_TIME.getTimeStampByNow();
            state.advanced.siZhuEightWordArr = FATE_DATA_MANAGER.getCurrentEightWordArr(formData);
        },
        [types.COLLATE_SIZHU_UPDATE_SAME_EIGHT_WORD](state) {
            // console.log('updateSameEightWordList-----', state.advanced.sameEightWordList)
            state.advanced.sameEightWordList = FATE_DATA_MANAGER.getSameEightWordList(state.advanced.siZhuEightWordArr);
            if(state.advanced.sameEightWordList.length == 0){
                AppFate.$toast('不存在这样的八字');
            }else{
                for(var data of state.advanced.sameEightWordList) {
                    if(data.selected){
                        state.formData.birthday = data.birthday;
                        console.log('selected-----birthday', data.birthday)
                    }
                }
            }
        },
        [types.COLLATE_SIZHU_AUTO_SHOW_CHOOSE_ITEM_POP](state, data) {
            var nyrs = parseInt(AppFate.$store.state.setting.settingConfigData.nianyueRishi);
            // 已经到最后一个了
            if((nyrs == 0 && data.newPos[0] > 3) || (nyrs == 1 && data.newPos[0] < 0)){
                AppFate.$store.dispatch('collate/updateSameEightWordList')
                return;
            }
            console.error('auto-------', data.newPos, state.advanced.siZhuEightWordArr)
            var newPos = nyrs == 1 ? [3-data.newPos[0], data.newPos[1]] : data.newPos,
                compData = state.advanced.siZhuEightWordArr[newPos[0]][1];
            // 自动弹框并更新弹框数据
            state.advanced.showChooseItemPop = true;
            state.advanced.collateClickBoxPos = data.newPos;

            // 处理数据
            AppFate.$store.dispatch('collate/updateCollateChooseData', {
                data: data.newData, pos: newPos
            });
            // 到地支的时候做一下属性判断和处理
            if(newPos[1] == 1){
                var origiList = state.advanced.siZhuEightWordArr,
                    firstData = state.advanced.collateChooseItemList[0],
                    index = COLLATE_DATA_MANAGER.checkTextDataIndexInEightWordArr(state.advanced.collateChooseItemList, compData);

                // console.log('----------', state.advanced.collateChooseItemList, firstData.text, compData.text, index)
                // 如果当前地支不在自动过滤的数组里的话，设置数组的第一个数据为选中
                if(index == -1){
                    firstData.selected = true;
                    state.advanced.siZhuEightWordArr = FATE_DATA_MANAGER.updateEightWordArrByData(origiList, [newPos[0], 1], firstData);
                    AppFate.$store.dispatch('collate/updateSameEightWordList')
                }else{
                    state.advanced.collateChooseItemList[index].selected = true;
                }
            }

            setTimeout(() => {
                DOM.updateChooseItemPopPos(data.newPos, data.basicPos, data.itemSize);
            }, 0);
        },
        [types.COLLATE_UPDATE_CHOOSE_ITEM_POP_DATA](state, data){
            var textData = data.data, pos = data.pos;
            var compData = state.advanced.siZhuEightWordArr[pos[0]][0];
            if(pos[1] == 0){
                // 天干
                state.advanced.collateChooseItemList = COLLATE_DATA_MANAGER.getTianGanListByCompData({});
            }else if(pos[1] == 1){
                // 地支
                state.advanced.collateChooseItemList = COLLATE_DATA_MANAGER.getDiZhiListByCompData(compData, textData);
            }
            console.log('types.COLLATE_UPDATE_CHOOSE_ITEM_POP_DATA------', state.advanced.collateChooseItemList);
        },
        [types.COLLATE_CHOOSE_ITEM_POP_DATA](state, data){
            var origiList = state.advanced.siZhuEightWordArr, 
                pos = state.advanced.collateClickBoxPos,
                newData = data.data, basicPos = data.basicPos, itemSize = data.itemSize;
            var nyrs = parseInt(AppFate.$store.state.setting.settingConfigData.nianyueRishi),
                dataPos = nyrs == 1 ? [3-pos[0], pos[1]] : pos;
            // console.log('types.COLLATE_CHOOSE_ITEM_POP_DATA----', origiList, pos, newData, basicPos, itemSize);
            state.advanced.siZhuEightWordArr = FATE_DATA_MANAGER.updateEightWordArrByData(origiList, dataPos, newData);
            
            // 自动弹出地支的弹框交互
            var newPos = [];
            if(nyrs == 0) { newPos = pos[1] == 0 ? [pos[0], 1] : [pos[0]+1, 0]; }
            if(nyrs == 1) { newPos = pos[1] == 0 ? [pos[0], 1] : [pos[0]-1, 0]; } 
            console.error('newPos--------', pos, newPos, newData.text)
            setTimeout(() => {
                AppFate.$store.dispatch('collate/autoShowChooseItemPop', {
                    newPos: newPos, newData: newData, basicPos: basicPos, itemSize: itemSize
                });
            }, 100);
        },
        [types.COLLATE_START_SIZHU_COLLATE](state, formData) {
            if(formData.location != ''){
                formData['real_time'] = FORMAT.getRealSunTimeByData(formData.location, formData.birthday);
            }
            var rt = parseInt(AppFate.$store.state.setting.settingConfigData.rt);
                formData['rt'] = rt;
            console.log("COLLATE_START_SIZHU_COLLATE---", formData);
    
            // for test
            // var date = formData.birthday;
            // // var date = MOMENT_TIME.getUnixTimeByTimeStr('1802-01-15 00:00:00');
            // // var date = MOMENT_TIME.getUnixTimeByTimeStr('1801-10-31 09:00:00');
            // // var date = MOMENT_TIME.getUnixTimeByTimeStr('1839-10-12 09:00:00');
            // var paipan = PAIPAN.GetInfo(0, date, 1);
            // console.log('date-----', date, paipan);
            // return;
            // for test

            // for test
            // var date = MOMENT_TIME.getUnixTimeByTimeStr("1500-02-29 00:00:00")
            // console.log('date-----', date);
            // return;
            // for test


            API.addPaiPan(formData, function (data) {

                AppFate.$store.dispatch('detail/resetData');
                AppFate.$store.dispatch('detail/initDetail', data);
                AppFate.$router.replace('/detail/collate_advancedcollate/'+ data.id);

                // 更新列表数据
                AppFate.$store.dispatch('record/updateRecordListData', data);
                // 更新分组数据
                var groupData = AppFate.$store.state.group.groupData;
                var recordData = RECORD_DATA_MANAGER.getRecordDataByData(data, groupData);
                AppFate.$store.dispatch('group/updateGroupListData', recordData);
                // 处理过滤列表数据
                AppFate.$store.dispatch('record/updateRecordFilterList');
            });
        },
        [types.COLLATE_RESET_DATA](state) {
            // 重置起盘输入表单数据
            state.showArea = false;
            state.selectedArea = [];
            state.showBirthday = false;
            state.selectedBirthday = [];
            for(var keys in state.formData){
                state.formData[keys] = '';
            }
            for(var keys in state.inputData){
                state.inputData[keys] = '';
            }
            state.advanced = {
                siZhuEightWordArr: [],
                showChooseItemPop: false,
                collateClickBoxPos: [],
                collateChooseItemList: [],
                sameEightWordList: []
            };
            state.chooseGroupFromPage = '';
            state.curStartCollateType = '';
        },
        [types.COLLATE_INIT_FORM_DATA](state, data) {
            console.log('COLLATE_INIT_FORM_DATA-------', data);
            // 根据用户信息初始化编辑页的表单数据:用于填入
            state.formData = COLLATE_DATA_MANAGER.getFormDataByPersonData(data);
            state.inputData = COLLATE_DATA_MANAGER.getInputDataByPersonData(data);
            state.selectedBirthday = COLLATE_DATA_MANAGER.getSelectedBirthdayStringByDetailData(data);
            var checkData = data.location;
            if (checkData.indexOf("不选择") != -1 ) {
                state.selectedArea = [];
            }else if(checkData.indexOf("海外地区") != -1){
                state.selectedArea = ['海外地区 北半球'];
            }else {
                state.selectedArea = COLLATE_DATA_MANAGER.getSelectedAreaStringByString(data.location);
            }
        }
    },
    actions: {
        confirmCollateArea({ commit }, areaArr) {
            commit(types.COLLATE_CONFIRM_AREA, areaArr);
        },
        confirmCollateBirthday({ commit }, birthData) {
            commit(types.COLLATE_CONFIRM_BIRTHDAY, birthData);
        },
        submitCollate({ commit }, params) {
            commit(types.COLLATE_START_COLLATE, params);
        },
        submitReport({ dispatch }, params) {
            console.log('submitReport-------', params.formData)
            // 如果选了出生地的话，传入真太阳时
            if(params.formData.location && params.formData.location != ''){
                if(FORM.checkFormLocationSpecial(params.formData.location)) {
                    params.formData['real_time'] = params.formData.birthday;
                }else {
                    params.formData['real_time'] = FORMAT.getRealSunTimeByData(params.formData.location, params.formData.birthday);
                }
            }
            var rt = parseInt(AppFate.$store.state.setting.settingConfigData.rt);
            params.formData['rt'] = rt;

            API.addPaiPan(params.formData, function (data) {

                AppFate.$store.dispatch('detail/resetData');
                AppFate.$store.dispatch('detail/initDetail', data);
                // 跳转到report页面
                dispatch('report/initReportAIConfig', null, {root: true});
                dispatch('report/getReportInfo', {
                    detailInfo: data,
                    cb: function() {
                        if(params.cb && typeof(params.cb) == 'function') {
                            params.cb(data.id)
                        }
                    }
                }, {root: true});

                // 更新列表数据
                dispatch('record/updateRecordListData', data, {root: true});
                // 更新分组数据
                var groupData = AppFate.$store.state.group.groupData;
                var recordData = RECORD_DATA_MANAGER.getRecordDataByData(data, groupData);
                dispatch('group/updateGroupListData', recordData, {root: true});
                // 处理过滤列表数据
                dispatch('record/updateRecordFilterList', null, {root: true});
            });
        },
        submitYear({ dispatch }, params) {
            console.log('submitYear-------', params.formData)
            // 如果选了出生地的话，传入真太阳时
            if(params.formData.location && params.formData.location != ''){
                if(FORM.checkFormLocationSpecial(params.formData.location)) {
                    params.formData['real_time'] = params.formData.birthday;
                }else {
                    params.formData['real_time'] = FORMAT.getRealSunTimeByData(params.formData.location, params.formData.birthday);
                }
            }
            var rt = parseInt(AppFate.$store.state.setting.settingConfigData.rt);
            params.formData['rt'] = rt;

            API.addPaiPan(params.formData, function (data) {

                dispatch('detail/resetData', null, {root: true});
                dispatch('detail/initDetail', data, {root: true});
                // 跳转到report页面
                dispatch('year/initYearCharacter', {
                    detailInfo: data,
                    characterCb: function() {
                        if(params.cb && typeof(params.cb) == 'function') {
                            params.cb(data.id)
                        }
                    }
                }, {root: true});

                // 更新列表数据
                dispatch('record/updateRecordListData', data, {root: true});
                // 更新分组数据
                var groupData = AppFate.$store.state.group.groupData;
                var recordData = RECORD_DATA_MANAGER.getRecordDataByData(data, groupData);
                dispatch('group/updateGroupListData', recordData, {root: true});
                // 处理过滤列表数据
                dispatch('record/updateRecordFilterList', null, {root: true});
            });
        },
        initSizhuCollate({ dispatch, commit }) {
            commit(types.COLLATE_SIZHU_INIT_DATA);
            dispatch('updateSameEightWordList');
        },
        updateSameEightWordList({ commit }) {
            commit(types.COLLATE_SIZHU_UPDATE_SAME_EIGHT_WORD);
        },
        autoShowChooseItemPop({ commit }, data) {
            commit(types.COLLATE_SIZHU_AUTO_SHOW_CHOOSE_ITEM_POP, data)
        },
        updateCollateChooseData({ commit }, data) {
            commit(types.COLLATE_UPDATE_CHOOSE_ITEM_POP_DATA, data)
        },
        chooseCollateChooseData({ commit }, data) {
            commit(types.COLLATE_CHOOSE_ITEM_POP_DATA, data)
        },
        submitSiZhuCollate({ commit }, formData) {
            commit(types.COLLATE_START_SIZHU_COLLATE, formData)
        },
        resetData({ commit }){
            commit(types.COLLATE_RESET_DATA)
        },
        initCollateFormData({ commit }, data){
            commit(types.COLLATE_INIT_FORM_DATA, data)
        }
    }
}